import { StyleSheet } from 'react-native';
import { spacing, ticketColors } from '../theme/public-api';

/**
 * Roles de superficie ticket.
 * screen = root de pantalla · counter = sheet/shell · paper = paneles/inputs · paper2 = anidados.
 * paperSheet = card blanca Square (Inicio / Cuenta / listas).
 */
export const ticketSurfaces = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: ticketColors.bg,
  },
  counter: {
    backgroundColor: ticketColors.counter,
  },
  paper: {
    backgroundColor: ticketColors.paper,
  },
  paper2: {
    backgroundColor: ticketColors.paper2,
  },
  /** Card blanca canónica (ruleSoft, radius 14). Preferir `<PaperSheet>` en JSX. */
  paperSheet: {
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 14,
    overflow: 'hidden',
    alignSelf: 'stretch',
  },
  paperSheetPadded: {
    padding: spacing.md,
  },
  panel: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    padding: spacing.md,
  },
  input: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
  },
});
